import React from 'react';
import { Center } from '@chakra-ui/react';

import baseStyle from '../styles/baseStyle';

type GrayDayProps = {
  day: number;
};

const GrayDay: React.FC<GrayDayProps> = ({ day }) => {
  return (
    <Center {...baseStyle} color="admin.gray.600">
      {day}
    </Center>
  );
};

export default GrayDay;
